import PropTypes from 'prop-types';

export const vhFilePropTypes = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.number,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  isDeleted: PropTypes.bool,
  hashId: PropTypes.string,
  organisationId: PropTypes.number,
  defaultType: PropTypes.string,
  tusId: PropTypes.string,
  tusUrl: PropTypes.string,
  url: PropTypes.string,
  transcodedUrl: PropTypes.string,
  jobId: PropTypes.number,
  transcodingStatus: PropTypes.string,
  conversationItemId: PropTypes.number,
});

// item that is saved into redux representing the result of an investigation or exam
export const resultItem = PropTypes.shape({
  id: PropTypes.number,
  title: PropTypes.string,
  actionKey: PropTypes.string,
  inputType: PropTypes.string,
  metric: PropTypes.string,
  normalValueMin: PropTypes.string,
  normalValueMax: PropTypes.string,
  parentActionId: PropTypes.number,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  organisationId: PropTypes.number,
  actionGroupId: PropTypes.number,
  sortOrder: PropTypes.number,
  patientId: PropTypes.number,
  text: PropTypes.string,
  imageId: PropTypes.number,
  audioId: PropTypes.number,
  videoId: PropTypes.number,
  value: PropTypes.string,
  audio: vhFilePropTypes,
  image: vhFilePropTypes,
  video: vhFilePropTypes,
});
